import { render, staticRenderFns } from "./CtaSubArea.vue?vue&type=template&id=18b642d5&scoped=true&"
import script from "./CtaSubArea.vue?vue&type=script&lang=js&"
export * from "./CtaSubArea.vue?vue&type=script&lang=js&"
import style0 from "./CtaSubArea.vue?vue&type=style&index=0&id=18b642d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b642d5",
  null
  
)

export default component.exports